import React from 'react';
import CareerMentorshipAdminContainer from '../../../Containers/AdminContainer/CareerMentorship';
const CareerMentorshipAdminScreen = () => {
  return <CareerMentorshipAdminContainer />;
};

export default CareerMentorshipAdminScreen;
